import React from 'react';
import { HighlightedCard } from '@sato/components';
import { observer } from 'mobx-react-lite';

import { Link } from '@components/common/Link';
import { ROUTES } from '@routes/routes.constants';
import { localizationStore } from '@stores/localization';

export const WaterUsageCard = observer(
  ({ className }: { className?: string }) => {
    const t = localizationStore.getTranslation;

    return (
      <HighlightedCard
        layout="horizontal"
        icon="water"
        iconPosition="left"
        title={t('waterUsage')}
        body={t('waterUsageDetails')}
        buttonProps={{
          children: t('waterUsageLink'),
          icon: 'arrowRight',
          iconPosition: 'right',
          to: ROUTES.WATER_USAGE,
          wrapperComponent: Link,
        }}
        color="tertiary"
        className={className}
      />
    );
  }
);
